/*
 *
 * Partner Logos constants
 *
 */

export const PARTNER_LOGOS_CHANGE = 'src/PartnerLogos/PARTNER_LOGOS_CHANGE';
export const PARTNER_LOGOS_EDIT_CHANGE = 'src/PartnerLogos/PARTNER_LOGOS_EDIT_CHANGE';
export const PARTNER_LOGOS_ADD = 'src/PartnerLogos/PARTNER_LOGOS_ADD';
export const PARTNER_LOGOS_DELETE = 'src/PartnerLogos/PARTNER_LOGOS_DELETE';
export const PARTNER_LOGOS_GET = 'src/PartnerLogos/PARTNER_LOGOS_GET';
export const PARTNER_LOGOS_GET_ALL = 'src/PartnerLogos/PARTNER_LOGOS_GET_ALL';
export const PARTNER_LOGOS_RESET = 'src/PartnerLogos/PARTNER_LOGOS_RESET';
export const SET_PARTNER_LOGOS_LOADING = 'src/PartnerLogos/SET_PARTNER_LOGOS_LOADING';
export const SET_PARTNER_LOGOS_FORM_ERRORS = 'src/PartnerLogos/SET_PARTNER_LOGOS_FORM_ERRORS';
export const SET_PARTNER_LOGOS_FORM_EDIT_ERRORS = 'src/PartnerLogos/SET_PARTNER_LOGOS_FORM_EDIT_ERRORS';
